/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RuntimeMediaAudioMetadataResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiTenantsTenantIdRuntimeMediaAudioMetadataUrl = (tenantId: string,) => {




  return `/api/tenants/${tenantId}/runtime-media-audio/metadata`
}

export const getApiTenantsTenantIdRuntimeMediaAudioMetadata = async (tenantId: string, options?: RequestInit): Promise<RuntimeMediaAudioMetadataResponse> => {

  return orvalControlFetch<RuntimeMediaAudioMetadataResponse>(getGetApiTenantsTenantIdRuntimeMediaAudioMetadataUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryKey = (tenantId: string,) => {
    return [
    `/api/tenants/${tenantId}/runtime-media-audio/metadata`
    ] as const;
    }


export const getGetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError = unknown>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>> = ({ signal }) => getApiTenantsTenantIdRuntimeMediaAudioMetadata(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>>
export type GetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryError = unknown


export function useGetApiTenantsTenantIdRuntimeMediaAudioMetadata<TData = Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError = unknown>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>,
          TError,
          Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenantsTenantIdRuntimeMediaAudioMetadata<TData = Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>,
          TError,
          Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTenantsTenantIdRuntimeMediaAudioMetadata<TData = Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTenantsTenantIdRuntimeMediaAudioMetadata<TData = Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError = unknown>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTenantsTenantIdRuntimeMediaAudioMetadata>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTenantsTenantIdRuntimeMediaAudioMetadataQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






